
































































import { Component, Vue, Inject } from "vue-property-decorator";
import Footer from "../components/Footer.vue";
import TenantSwitch from "../components/tenant-switch.vue";
import LanguageSwitch from "../components/language-switch.vue";
import AbpBase from "../lib/abpbase";
import util from "@/lib/util";
import * as proxy from "@/lib/service-proxies/service-proxies";
@Component({
  components: { Footer, TenantSwitch, LanguageSwitch },
})
export default class Login extends AbpBase {
  loginModel = {
    userNameOrEmailAddress: "",
    password: "",
    rememberMe: false,
    googleCode: "",
    userType: 0,
    loginId: "",
  };
  logincode = "";
  showChangeTenant: boolean = false;
  async login() {
    if (!this.loginModel.userNameOrEmailAddress) {
      this.$Notice.error({ title: "请输入账号" });
      return;
    }
    if (!this.loginModel.password) {
      this.$Notice.error({ title: "请输入密码" });
      return;
    }
    this.$Message.loading({
      content: this.L("LoginPrompt"),
      duration: 0,
    });
    await this.$store.dispatch({
      type: "app/login",
      data: this.loginModel,
    });
    sessionStorage.setItem(
      "rememberMe",
      this.loginModel.rememberMe ? "1" : "0"
    );
    location.reload();
  }
  get tenant() {
    return this.$store.state.session.tenant;
  }
  rules = {
    userNameOrEmailAddress: [
      { required: true, message: this.L("UserNameRequired"), trigger: "blur" },
    ],
    password: [
      { required: true, message: this.L("PasswordRequired"), trigger: "blur" },
    ],
  };
  created() {
    // if (this.$route.query.logintoken) {
    //   var token = this.$route.query.logintoken;
    //   var tokenExpireDate = new Date(
    //     new Date().getTime() + 1000 * 24 * 60 * 60
    //   );
    //   util.abp.auth.setToken(token, tokenExpireDate);
    //   location.reload();
    // } else {
    new proxy.TokenAuthServiceProxy().generateCode().then((x) => {
      let json = JSON.parse(x);
      this.loginModel.loginId = json.id;
      this.logincode = json.code;
    });
    // }
  }
  mounted() {
    let w = window as any;

    w.particlesJS(
      "particles-js",

      {
        particles: {
          number: {
            value: 40,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: "#ffffff",
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#000000",
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              src: "img/github.svg",
              width: 100,
              height: 100,
            },
          },
          opacity: {
            value: 0.7,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 3,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#ffffff",
            opacity: 0.6,
            width: 1,
          },
          move: {
            enable: true,
            speed: 6,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: true,
              mode: "grab",
            },
            onclick: {
              enable: true,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 200,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: false,
      }
    );
  }
}
